import { Store } from 'libx'
import { observable, action } from 'mobx'
import { browserHistory } from 'react-router'
import links from 'misc/links'
import { task } from 'mobx-task'

export default class ProjectScreenStore extends Store {
  @observable showingFreeExtensionsInfo = false

  @task async fetchProjects () {
    await this.rootStore.projectStore.fetchProjects()
  }

  @task activate () {
    return Promise.all([
      this.rootStore.rateProjectStore.ensureAllRated(),
      this.fetchProjects()
    ])
  }

  @action showFreeExtensionsInfo () {
    this.showingFreeExtensionsInfo = true
  }

  @action closeFreeExtensionsInfo () {
    this.showingFreeExtensionsInfo = false
    this.rootStore.projectWizardStore.hereForFreeExtensions = true
    browserHistory.push(links.newProject())
  }
}



// WEBPACK FOOTER //
// ./src/client/store/ui/ProjectsScreenStore.js